<section *ngIf="!fetchingData else fetchingDataSpinner" class="hero-bg pt-1">  
  <div class="modal-header p-0 pt-1 pt-lg-3 pb-0 border-0">
    <div class="container">
      <img [src]="logo" alt="{{siteName}}" class="logo"/>
      <!-- <button (click)="closeDialog()" class="close" type="button"><span class="text-white">&times;</span></button> -->
    </div>
  </div>
  <div class="modal-body p-0">
    <div *ngIf="homepageNotice" class="my-2">
      <div class="container p-0 px-2">
        <h4 class="banner-notice text-center text-secondary text-4 p-2">{{homepageNotice}}</h4>
      </div>
    </div>
    <div class="container pt-4 pb-5">
      <div class="mb-0 mt-sm-3">
        <h1 class="text-15 banner-title mb-2">{{bannerTitle}}</h1>
        <h6 class="mb-4 banner-subtitle">{{bannerSubtitle}}</h6>
      </div>
      <form [formGroup]="userInfoForm" class="form-row row py-2 px-2 mb-4 px-sm-4 py-sm-4">
        <p class="col-12 text-3 mb-3 mt-0 text-white line-height-2">Fill out your details so we can find the right bus service for you.</p>
        <mat-form-field appearance="fill" class="col-12 col-lg-6 px-0 px-lg-1">
          <mat-label>First name</mat-label>
          <input type="text"
            aria-label="First name"
            matInput
            formControlName="firstName">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-lg-6 px-0 px-lg-1">
          <mat-label>Last name</mat-label>
          <input type="text"
            aria-label="Last name"
            matInput
            formControlName="lastName">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-lg-6 px-0 px-lg-1">
          <mat-label>Phone number</mat-label>
          <input type="text"
            aria-label="Phone number"
            matInput
            formControlName="phone">
        </mat-form-field>
        <div class="form-check col-12 ml-3 ml-lg-4 mb-3">
          <input class="form-check-input" type="checkbox" [checked]="terms" (change)="toggleTerms()" id="terms" name="terms">
          <label for="terms" class="text-white text-3 line-height-2 form-check-label">Receive discounts and promotions</label>
        </div>
        <div class="col-12 px-0">
          <button (click)="onSubmit()" class="btn btn-secondary btn-lg btn-block" [disabled]="loading">Proceed <mat-spinner diameter="22" *ngIf="loading"></mat-spinner></button>
        </div>
      </form>
      <div *ngIf="operators?.length" class="form-row operator-logos p-2 d-flex align-items-center justify-content-center">
        <ng-container *ngFor="let operator of operators">
          <img [alt]="operator.name" [title]="operator.name" class="operator-logos__item" src="{{operator.logo}}">
        </ng-container>
      </div>
    </div>
    <div class="modal-text">
      <div class="container py-4">
        <p class="text-white text-4 text-lg-center my-3 px-2">
          {{data?.text}}
        </p>
      </div>
    </div>
    <div class="modal-contact-info">
      <div class="container py-4">
        <h2 class="text-secondary text-center mt-4">Customer support</h2>
        <p class="text-4 text-center line-height-3 mt-2 mb-4 px-2">
          Call: <a href="tel:{{supportNumber}}">{{supportNumber}}</a><br/>
          Email: <a href="mailto:{{supportEmail}}">{{supportEmail}}</a>
        </p>
      </div>
    </div>
  </div>
</section>
<ng-template #fetchingDataSpinner>
  <section class="d-flex justify-content-center align-items-center h-100">
    <mat-spinner diameter="40" class="data-spinner"></mat-spinner>
  </section>
</ng-template>